export default __webpack_public_path__ + "static/candlewax-fb3673ba48ca6e01c784c6d1366ab482.png";